import { useFormikContext } from 'formik';
import React, { useEffect } from 'react';

interface FieldControllerSyncProps {
  fieldName: string;
  fieldValue?: string | null;
}
export const FieldControllerSync: React.FC<FieldControllerSyncProps> = ({
  fieldName,
  fieldValue,
}) => {
  const { setFieldValue } = useFormikContext<any>();

  useEffect(() => {
    if (fieldValue !== undefined) {
      setFieldValue(fieldName, fieldValue ?? '');
    }

    // eslint-disable-next-line
  }, [fieldName, fieldValue, setFieldValue]);

  return null;
};
